export default {
    url: '/ltvprediction',
    template: require('./main.html'),
    data: {
        priority: 900,
        title: 'LTV Prediction',
        role: 'life_time',
    },
    controller: [
        '$scope',
        'life_time_api',
        function ($scope, life_time_api) {
            $scope.start_ltvprediction_task = function(model) {
                life_time_api.start_ltvprediction_task({
                    date_from: model.date_from,
                    date_to: model.date_to,
                });
            };
        },
    ],
};
